import { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, Save } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

const HINTS = {
  "Fee Reminder": "One message for Upcoming, Due Today and Overdue — wording adjusts automatically. Tokens: {STATUS_LINE} {PACKAGE} {FEE_BREAKDOWN} {TOTAL} {DUE_DATE} {PLAYER} {PARENT}",
};
const slug = (s) => s.replace(/[^a-z0-9]+/gi, "-").toLowerCase();

const TemplateItem = ({ t, onSaved }) => {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(t.message);
  const save = async () => {
    try { await api.put(`/admin/templates/${t.id}`, { message: draft }); toast.success(`${t.stage} template saved`); onSaved(); }
    catch (err) { toast.error(formatApiError(err)); }
  };
  return (
    <div className="border-b border-white/5 last:border-0">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-5 text-left" data-testid={`template-toggle-${slug(t.stage)}`}>
        <span className="font-heading font-bold text-sm">{t.stage}<span className="text-white/40 font-normal text-xs ml-3">{HINTS[t.stage] || "Sent from receipts / welcome flow"}</span></span>
        {open ? <ChevronUp size={16} className="text-[#D4AF37]" /> : <ChevronDown size={16} className="text-white/40" />}
      </button>
      {open && (
        <div className="px-5 pb-5">
          <textarea rows={14} value={draft} onChange={(e) => setDraft(e.target.value)} className="w-full bg-[#050505] border border-[#D4AF37]/40 text-white/80 text-xs p-4 font-mono focus:outline-none focus:border-[#D4AF37]" data-testid={`template-text-${slug(t.stage)}`} />
          <button onClick={save} className="mt-3 flex items-center gap-2 bg-[#D4AF37] text-black text-xs font-bold uppercase tracking-widest px-5 py-2.5 rounded-sm hover:bg-[#F3D059] transition-colors duration-200" data-testid={`template-save-${slug(t.stage)}`}>
            <Save size={13} /> Save Template
          </button>
        </div>
      )}
    </div>
  );
};

export const ReminderTemplateEditor = ({ onSaved }) => {
  const [templates, setTemplates] = useState([]);
  const load = () => api.get("/admin/templates").then((r) => setTemplates(r.data.filter((t) => !t.stage.startsWith("Day")).sort((a, b) => (a.stage === "Fee Reminder" ? -1 : b.stage === "Fee Reminder" ? 1 : 0)))).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!templates.length) return null;
  return (
    <div className="border border-white/10 bg-[#0A0A0A] mt-10" data-testid="reminder-template-panel">
      <p className="text-xs tracking-[0.25em] uppercase text-[#D4AF37] font-semibold p-5 border-b border-white/10">Message Templates</p>
      {templates.map((t) => <TemplateItem key={t.id} t={t} onSaved={() => { load(); onSaved(); }} />)}
    </div>
  );
};
